<template>
  <div class="col-lg-12 control-section">
    <div class="tree-control-wrapper">
      <ejs-treeview ref='measureTreeForDataSearch' id='measureTreeForDataSearch' :fields='fieldsForDataSearch' :showCheckBox='true' :nodeChecked='nodeCheckedOfMeasureTreeForDataSearch'></ejs-treeview>
    </div>
  </div>
</template>

<script>

export default {
  name: 'MeasureTreeForDataSearch',
  props: [
    'checkedNodesOfMeasureTree'
  ],
  data() {
    return {
      fieldsForDataSearch: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text'
      },
      checkedNodesOfMeasureTreeForDataSearch: []
    };
  },
  methods: {
    getMeasureTreeForDataSearch(neTypeId,counterTypeId) {
      this.$axios.post(`/lte/pm/getKpiTree.html?neTypeId=${neTypeId}&neVersionId=V16B.006&counterTypeId=${counterTypeId}&timeCycle=2`).then((response) => {
     //  isChecked
        const meIds = this.checkedNodesOfMeasureTreeForDataSearch.map(element => element.id);

        response.data[0].children.forEach(subs => {
              subs.children.forEach(element => {
                if(meIds.includes(element.id)){
                  element.isChecked = true;
                }
              })
        });

        
        this.fieldsForDataSearch = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    },
    nodeCheckedOfMeasureTreeForDataSearch(args) {

      //临时存储上一次的结果
      let tempOfSelectedNodes = {};
      for ( let i = 0; i < this.checkedNodesOfMeasureTreeForDataSearch.length; i++) {
        tempOfSelectedNodes[this.checkedNodesOfMeasureTreeForDataSearch[i]['id']] = this.checkedNodesOfMeasureTreeForDataSearch[i]['id'];
      }

      //针对本次变化处理
      for (let i = 0;  i < args.data.length; i++) {
        if(args.action==="check"){
          if(tempOfSelectedNodes[args.data[i].id]){
            //如果上次就已经选中了，本次就不能重复填加了
          }else{
            tempOfSelectedNodes[args.data[i].id]=args.data[i].id;
          }

        }else{
          delete tempOfSelectedNodes[args.data[i].id];
        }
      }

      const checkedNodes = [];

      for(let item in tempOfSelectedNodes){
        checkedNodes.push(item);
      }


      let selectedNodes = [];



      let dataLevel1 = this.$refs.measureTreeForDataSearch.getTreeData()[0].children;
      for (let index = 0; index < dataLevel1.length; index++) {
        for(let i = 0; i < dataLevel1[index].children.length; i++){
          if(checkedNodes.indexOf(dataLevel1[index].children[i].id) != -1){
            selectedNodes.push(dataLevel1[index].children[i]);
          }
        }
      }
      this.checkedNodesOfMeasureTreeForDataSearch = selectedNodes;
    }
  },
  watch: {
    checkedNodesOfMeasureTree(checkedNodesOfMeasureTree) {
      this.checkedNodesOfMeasureTreeForDataSearch = checkedNodesOfMeasureTree;
    }
  },
  mounted() {
  }
};
</script>

<style>

</style>
